<template>
  <v-container fluid>
    <v-layout row wrap class="mb-2 mx-0">
      <v-flex xs12 sm3 md3>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-3">
          <el-breadcrumb-item :to="{ path: '/' }">แดชบอร์ด</el-breadcrumb-item>
          <el-breadcrumb-item>ออเดอร์เดือนนี้</el-breadcrumb-item>
        </el-breadcrumb>
      </v-flex>
      <v-flex xs12 sm9 md9 class="text-xs-right">
        <el-card class="box-card" id="stat">
          <v-layout wrap>
            <v-flex class="text-xs-center">
              <strong style="font-size:0.7rem">ยอดขาย</strong>
              <br />
              <h6 class="mt-0">฿ {{ amount.revenue | numFormat("0,0.00") }}</h6>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong style="font-size:0.7rem">ค่าสินค้า</strong>
              <br />
              <h6 class="mt-0">
                ฿
                {{
                  (parseFloat(amount.food) + parseFloat(amount.vat))
                    | numFormat("0,0.00")
                }}
              </h6>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong style="font-size:0.7rem">ค่าจัดส่ง</strong>
              <br />
              <h6 class="mt-0">
                ฿
                {{
                  (amount.delivery + amount.delivery_tax) | numFormat("0,0.00")
                }}
              </h6>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong style="font-size:0.7rem">ส่วนลด</strong>
              <br />
              <h6 class="mt-0">
                ฿ {{ amount.discount | numFormat("0,0.00") }}
              </h6>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center">
              <strong style="font-size:0.7rem">จำนวนบิล</strong>
              <br />
              <h6 class="mt-0">
                {{ amount.count_order | numFormat("0,0") }}
              </h6>
            </v-flex>
            <v-divider class="mx-4" vertical></v-divider>
            <v-flex class="text-xs-center"> </v-flex>
          </v-layout>
        </el-card>
      </v-flex>
    </v-layout>

    <v-row no-gutters>
      <v-col :cols="9">
        <v-tabs v-model="activeTab" slider-color="primary" flat class="pt-3">
          <v-tab @click="handleTabChanged('all')">ทั้งหมด</v-tab>
          <v-tab @click="handleTabChanged('pending')">ยังไม่ชำระเงิน</v-tab>
          <v-tab @click="handleTabChanged('new')">แนบสลิปแล้ว</v-tab>
          <v-tab @click="handleTabChanged('accepted')">ยืนยันแล้ว</v-tab>
          <v-tab @click="handleTabChanged('processing')">กำลังแพ็คสินค้า</v-tab>
          <v-tab @click="handleTabChanged('completed')">จัดส่งแล้ว</v-tab>
        </v-tabs>
      </v-col>
      <v-col :cols="3" align-self="center">
        <!-- <el-button
          icon="fas fa-file-download"
          style="float: right; padding: 3px 0"
          type="text"
          @click="downloadReport"
          >&nbsp;ดาวน์โหลด</el-button
        > -->
      </v-col>
    </v-row>

    <el-card class="mt-0">
      <v-data-table
        :headers="headers"
        :items="resultList"
        :loading="isLoading"
        :page.sync="page"
        @page-count="pageCount = $event"
        :options.sync="options"
        :server-items-length="totalItems"
        :height="height"
        class="elevation-0"
      >
        <template v-slot:no-data>
          <div class="text-xs-center">
            <img src="../../../assets/img/no-order.png" style="width: 30%" />
          </div>
        </template>

        <template v-slot:item.order_type="{ item }">
          <div style="min-height: 60px; width: 140px">
            <div class="pt-3">
              <el-tooltip
                content="เดลิเวอรี่"
                placement="top"
                v-if="item.order_type == 'delivery'"
              >
                <i class="fas fa-motorcycle mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="คอมเมิร์ซ"
                placement="top"
                v-if="item.order_type == 'commerce'"
              >
                <i class="fas fa-shopping-bag mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="รับเองที่ร้าน"
                placement="top"
                v-if="item.order_type == 'pickup'"
              >
                <i class="fas fa-store mr-2"></i>
              </el-tooltip>

              <span class="grey--text">{{ item.order_reference }}-</span>
              {{ item.order_id | numFormat("00000") }}
            </div>

            <div
              v-if="item.status == 'cancelled'"
              class="grey lighten-2 badge-status"
            >
              ยกเลิกแล้ว
            </div>
            <div
              v-if="item.status == 'pending'"
              class="grey darken-2 badge-status"
            >
              <i class="far fa-clock"></i> รอชำระเงิน
            </div>
            <div v-else-if="item.status == 'new'">
              <div v-if="item.shop_id != 369" class="red badge-status">
                มาใหม่
              </div>
              <div v-else>
                <div v-if="item.verified_slip" class="red badge-status">
                  มาใหม่
                </div>
                <div v-else class="black badge-status">รอตรวจสอบ</div>
              </div>
            </div>
            <div
              v-if="item.status == 'accepted' || item.status == 'captured'"
              class="amber darken-1 badge-status"
            >
              ยืนยันแล้ว
            </div>
            <div
              v-if="item.status == 'processing'"
              class="blue darken-2 badge-status"
            >
              ส่งให้ร้านแล้ว
            </div>
            <div
              v-if="item.status == 'cooking'"
              class="blue darken-4 badge-status"
            >
              กำลังดำเนินการ
            </div>
            <div
              v-if="item.status == 'ready-to-go'"
              class="pink lighten-3 badge-status"
            >
              พร้อมจัดส่ง
            </div>
            <div
              v-if="item.status == 'delivering'"
              class="pink lighten-1 badge-status"
            >
              กำลังจัดส่ง
            </div>
            <div
              v-if="item.status == 'completed'"
              class="green lighten-1 badge-status"
            >
              เรียบร้อยแล้ว
            </div>
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <el-button type="text" size="small" @click="openItem(item)"
            >ดูรายละเอียด</el-button
          >
        </template>

        <template v-slot:item.datetime_received="{ item }">
          <!-- เวลารับอาหาร -->
          <div style="width: 150px">
            <div>{{ item.datetime_received | moment("DD/MM/YY HH:mm") }}</div>
            <div v-if="item.cluster_id != null">
              <el-tag
                v-if="
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                "
                size="mini"
                type="info"
                >รอบส่ง
                {{
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                    .delivery
                }}</el-tag
              >
            </div>
            <div v-if="item.driver_info_json != null">
              <a
                v-if="item.driver_type == 'lalamove'"
                :href="
                  `https://share.lalamove.com/?TH` +
                    item.driver_info_json.orderRef +
                    `&lang=th_TH`
                "
                target="_blank"
              >
                <img
                  src="../../../assets/img/icon-lalamove.png"
                  style="width: 20px"
                />
              </a>

              <img
                v-if="item.driver_type == 'grab-instant'"
                src="../../../assets/img/icon-grab-instant.png"
                style="width: 20px"
              />
            </div>
          </div>
        </template>

        <template v-slot:item.user_ref_json="{ item }">
          <!-- ข้อมูลลูกค้า -->
          <div style="width: 120px">
            <template v-if="item.user_ref_json != null">
              <strong class="line-1-elipsis"
                >{{ item.user_ref_json.firstname }}
                {{ item.user_ref_json.lastname }}</strong
              >
              <div>
                <span class="font-xs">
                  <i class="fas fa-mobile-alt"></i>
                  {{ item.user_ref_json.mobile }}
                </span>
              </div>
            </template>
          </div>
        </template>

        <template v-slot:item.user_address="{ item }">
          <div style="width: 220px; padding: 10px 0">
            <p class="progress__title">
              <span v-if="item.user_address != null">{{
                item.user_address.label
              }}</span>
              <template v-if="item.user_address">
                <span v-if="item.user_address.place_detail != null">
                  {{ item.user_address.place_detail.address }}
                  {{ item.user_address.place_detail.sub_district }}
                  {{ item.user_address.place_detail.district }}
                  {{ item.user_address.place_detail.postcode }}
                </span>
              </template>
            </p>
          </div>
        </template>

        <template v-slot:item.postalcode="{ item }">
          <div style="width: 100px; padding: 10px 0">
            {{ item.postalcode }}
          </div>
        </template>

        <template v-slot:item.amount="{ item }">
          <div>
            <strong>฿ {{ item.amount.total | numFormat("0,0.00") }}</strong>
            <br />

            <span
              class="font-xs grey--text"
              v-if="item.payment_type == 'transfer'"
            >
              โอนเงิน
              <!-- <i
                v-if="item.payment.payment_image_url != null"
                @click="viewSlip(item.payment.payment_image_url)"
                class="far fa-file-image"
              ></i> -->
            </span>
            <span class="font-xs grey--text" v-if="item.payment_type == 'cash'"
              >ชำระเงินสด</span
            >
            <span
              class="font-xs grey--text"
              v-if="item.payment_type == 'creditcard'"
              >บัตรเครดิต</span
            >
          </div>
        </template>

        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">
              <div>
                <span class="grey--text"
                  >{{ props.item.order_reference }}-</span
                >
                {{ props.item.order_id | numFormat("00000") }}
              </div>
              <div
                v-if="props.item.status == 'cancelled'"
                class="grey lighten-2 badge-status centered"
              >
                ยกเลิกแล้ว
              </div>
              <div
                v-if="props.item.status == 'pending'"
                class="grey darken-2 badge-status centered"
              >
                <i class="far fa-clock"></i> รอชำระเงิน
              </div>
              <div
                v-else-if="props.item.status == 'new'"
                class="red badge-status centered"
              >
                มาใหม่
              </div>
              <div
                v-if="
                  props.item.status == 'accepted' ||
                    props.item.status == 'captured'
                "
                class="amber darken-1 badge-status centered"
              >
                ยืนยันแล้ว
              </div>
              <div
                v-if="props.item.status == 'processing'"
                class="blue darken-2 badge-status centered"
              >
                กำลังแพ็คสินค้า
              </div>
              <div
                v-if="props.item.status == 'cooking'"
                class="blue darken-4 badge-status centered"
              >
                กำลังแพ็คสินค้า
              </div>
              <div
                v-if="props.item.status == 'completed'"
                class="green lighten-1 badge-status centered"
              >
                จัดส่งแล้ว
              </div>
            </td>
            <td class="text-xs-left">
              <el-button type="text" size="small" @click="openItem(props.item)"
                >ดูรายละเอียด</el-button
              >
            </td>
            <td class="text-xs-left">
              <!-- เวลารับอาหาร -->
              <div style="width: 150px">
                <div>
                  {{ props.item.datetime_received | moment("DD/MM/YY HH:mm") }}
                </div>
                <div v-if="props.item.cluster_id != null">
                  <el-tag size="mini" type="info"
                    >รอบส่ง
                    {{
                      props.item.shop.cluster_json.find(
                        (x) => x.id == props.item.cluster_id
                      ).delivery
                    }}</el-tag
                  >
                </div>
                <div v-if="props.item.driver_info_json != null">
                  <a
                    v-if="props.item.driver_info_json.orderRef"
                    :href="
                      `https://share.lalamove.com/?TH` +
                        props.item.driver_info_json.orderRef +
                        `&lang=th_TH`
                    "
                    target="_blank"
                  >
                    <img
                      src="../../../assets/img/lalamove.png"
                      style="width: 40%"
                    />
                  </a>
                </div>
              </div>
            </td>
            <td class="text-xs-left">
              <!-- ข้อมูลลูกค้า -->
              <div style="width: 120px">
                <template v-if="props.item.user_ref_json != null">
                  {{ props.item.user_ref_json.firstname }}
                  {{ props.item.user_ref_json.lastname }}
                  <br />
                  <span class="font-xs">
                    <i class="fas fa-mobile-alt"></i>
                    {{ props.item.user_ref_json.mobile }}
                  </span>
                </template>
              </div>
            </td>
            <td class="text-xs-left">
              <!-- เส้นทาง -->
            </td>
            <td class="text-xs-left">
              <div style="width: 80px; padding: 10px 0">
                {{ props.item.user_address.place_detail.postcode }}
              </div>
            </td>
            <!-- จำนวนเงิน-->
            <td class="text-xs-left">
              <template>
                <strong
                  >฿ {{ props.item.amount.total | numFormat("0,0.00") }}</strong
                >
                <br />

                <span
                  class="font-xs grey--text"
                  v-if="props.item.payment_type == 'transfer'"
                >
                  โอนเงิน
                  <!-- <i
                    v-if="props.item.payment.payment_image_url != null"
                    @click="viewSlip(props.item.payment.payment_image_url)"
                    class="far fa-file-image"
                  ></i> -->
                </span>
                <span
                  class="font-xs grey--text"
                  v-if="props.item.payment_type == 'cash'"
                  >ชำระเงินสด</span
                >
                <span
                  class="font-xs grey--text"
                  v-if="props.item.payment_type == 'creditcard'"
                  >บัตรเครดิต</span
                >
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>

      <!-- <div
        style="
          position: fixed;
          bottom: 10px;
          right: 10px;
          z-index: 9;
          width: 100%;
        "
      >
        <v-pagination
          circle
          v-model="page"
          :total-visible="5"
          :length="pageCount"
        ></v-pagination>
      </div> -->
    </el-card>
  </v-container>
</template>

<script>
import Service from "@/services";
import moment from "moment";

import { mapState } from "vuex";

export default {
  data() {
    return {
      activeTab: 0,
      mode: "admin",
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
      isLoading: false,
      date: "",
      orderList: [],
      resultList: [],
      refresh: null,
      options: {
        page: 1,
        itemsPerPage: 30,
      },
      height: "calc(100vh - 310px)",
      amount: {
        revenue: 0,
        delivery: 0,
        delivery_tax: 0,
        food: 0,
        vat: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "order_type",
        },
        { text: "", value: "action", sortable: false },
        { text: "เวลาสั่งซื้อ", value: "datetime_received", sortable: false },
        { text: "ข้อมูลลูกค้า", value: "user_ref_json", sortable: false },
        { text: "การจัดส่ง", value: "user_address", sortable: false },
        { text: "Channel", value: "sale_channel", sortable: false },
        { text: "จำนวนเงิน", value: "amount", sortable: false },
      ],
      statusOrdering: [
        "new",
        "acccepted",
        "cooking",
        "processing",
        "completed",
        "cancelled",
      ],
      permission: null,
      paymentSlip: null,
      selectedStatus: null,
      totalItems: 0,
    };
  },
  watch: {
    options: {
      handler() {
        this.loadOrder();
      },
      deep: true,
    },
  },
  created() {
    Service.User.permission().then((resp) => {
      this.permission = resp.data;
      this.mode = this.permission.user.role_id;

      this.loadOrder();
    });

    this.date = moment().format("LLLL");

    /*
    this.refresh = setInterval(() => {
      this.loadOrder();
    }, 30000);*/
  },
  methods: {
    loadOrder() {
      this.isLoading = true;
      this.amount = {
        revenue: 0,
        delivery: 0,
        food: 0,
        vat: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        discount: 0,
        completed: 0,
      };

      let params = {
        order_type: "commerce",
        per_page: 30,
        current_page: this.options.page,
        status: this.selectedStatus,
        begin: moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD"),
        end: moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
      };

      if (params.status == null) {
        delete params.status;
      }

      Service.Stat.statSale(params).then((res) => {
        console.log(res);
        this.amount.revenue = res.data.total;
        this.amount.food = res.data.food_amount;
        this.amount.delivery = res.data.delivery_amount;
        this.amount.discount = res.data.discount_amount;
        this.amount.count_order = res.data.count_order;
      });

      // if (params.status == "processing") {
      //   params.sorting_key = "datetime_received";
      //   params.sorting_type = "asc";
      // }

      Service.Order.getCommerceOrders(params).then((res) => {
        this.isLoading = false;

        this.totalItems = res.data.total;
        this.orderList = res.data.rows.map((item) => {
          let postalcode = "";
          if (item.user_address.place_detail != null) {
            let s = item.user_address.place_detail.address.split(" ");
            if (!isNaN(s[s.length - 1])) {
              postalcode = s[s.length - 1];
            }

            if (item.user_address.place_detail.postcode) {
              postalcode = item.user_address.place_detail.postcode;
            }
          }

          let verified_slip = false;
          item.payments.map((payment) => {
            if (payment.slip2go_json) {
              if (payment.slip2go_json.code == 200200) {
                verified_slip = true;
              }
            }
          });
          return {
            ...item,
            postalcode: postalcode,
            verified_slip: verified_slip,
          };
        });

        // this.orderList.map((item) => {
        //   if (
        //     ["accepted", "processing", "cooking", "completed"].includes(
        //       item.status
        //     )
        //   ) {
        //     this.amount.revenue += parseFloat(item.amount.total);
        //     this.amount.delivery += parseFloat(item.amount.delivery);
        //     this.amount.delivery_tax += parseFloat(item.amount.delivery_tax);
        //     this.amount.food += parseFloat(item.amount.food);
        //     this.amount.vat += parseFloat(item.amount.vat);
        //     this.amount.extra += parseFloat(item.amount.extra);
        //     this.amount.discount += parseFloat(item.amount.discount);
        //     this.amount.completed++;

        //     let cog = 0;
        //     item.order_basket.product_list.map((product) => {
        //       cog += parseInt(product.cog) * product.quantity;
        //       this.amount.quantity += product.quantity;
        //     });
        //     item.amount.cog = cog;
        //     this.amount.cog += item.amount.cog;
        //   }
        // });
        this.resultList = this.orderList;
        // console.log(res);
      });

      return;
      Service.Order.gets("order_type=commerce&per_page=15").then((res) => {
        this.isLoading = false;
        if (res.success) {
          this.orderList = res.data.map((item) => {
            let postalcode = "";
            if (item.user_address.place_detail != null) {
              let s = item.user_address.place_detail.address.split(" ");
              if (!isNaN(s[s.length - 1])) {
                postalcode = s[s.length - 1];
              }

              if (item.user_address.place_detail.postcode) {
                postalcode = item.user_address.place_detail.postcode;
              }
            }
            return { ...item, postalcode: postalcode };
          });

          /*
          this.orderList.sort(
            (a, b) =>
              this.statusOrdering.indexOf(a.status) -
              this.statusOrdering.indexOf(b.status)
          );
          */

          this.orderList.map((item) => {
            if (
              ["accepted", "processing", "cooking", "completed"].includes(
                item.status
              )
            ) {
              this.amount.revenue += parseFloat(item.amount.total);
              this.amount.delivery += parseFloat(item.amount.delivery);
              this.amount.delivery_tax += parseFloat(item.amount.delivery_tax);
              this.amount.food += parseFloat(item.amount.food);
              this.amount.vat += parseFloat(item.amount.vat);
              this.amount.extra += parseFloat(item.amount.extra);
              this.amount.discount += parseFloat(item.amount.discount);
              this.amount.completed++;

              let cog = 0;
              item.order_basket.product_list.map((product) => {
                cog += parseInt(product.cog) * product.quantity;
                this.amount.quantity += product.quantity;
              });
              item.amount.cog = cog;
              this.amount.cog += item.amount.cog;
            }
          });
          this.resultList = this.orderList;
        }
      });
    },
    onNewOrder() {
      if (this.mode == "enterprise_manager") {
        let ent_id = this.permission.user.permission_json
          .included_enterprises[0];
        this.$router.push("/commerce/create/order?ent_id=" + ent_id);
      } else {
        this.$router.push("/commerce/create/order");
      }
    },
    openItem(item) {
      window
        .open("/commerce/view/order/" + item.order_reference, "_blank")
        .focus();
    },
    viewSlip(url) {
      this.paymentSlip = url;
    },
    handleTabChanged(type) {
      this.selectedStatus = type;
      this.options.page = 1;
      this.loadOrder();
      // if (type == "all") {
      //   this.resultList = this.orderList;
      // } else {
      //   this.resultList = this.orderList.filter((x) => x.status == type);
      // }
    },

    downloadReport() {
      let params = {
        begin: this.daterange[0],
        end: this.daterange[1],
        report: true,
        type: "download",
      };

      if (this.selectedShopId != null) {
        params.shop_id = this.selectedShopId;
      }

      var queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
      let accessToken = vuex.Auth.accessToken;

      var request = new XMLHttpRequest();

      request.responseType = "blob";
      request.onreadystatechange = (e) => {
        let _ = this;
        let filename = "ยอดขายทั้งหมด_";
        if (this.selectedShopId != null && this.selectedShopId.length == 1) {
          let filename = _.shopList.find((x) => x.shop_id == _.selectedShopId)
            .name;
        }
        if (request.readyState !== 4) {
          return;
        }
        if (request.status === 200) {
          //console.log("success", request.response);
          var fileURL = window.URL.createObjectURL(
            new Blob([request.response], {
              type: "application/vnd.ms-excel",
            })
          );
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sale_report_" + filename + ".xls");
          document.body.appendChild(fileLink);

          fileLink.click();
        } else {
          console.warn(request);
        }
      };

      request.onload = function(oEvent) {
        var blob = request.response;
      };

      request.open(
        "GET",
        "https://report-api.halalize.com/delivery/orders?" + queryString
      );
      request.setRequestHeader("Content-Type", "application/json");
      request.setRequestHeader("Authorization", "Bearer " + accessToken);
      //request.setRequestHeader("Accept", "*/*");
      //request.setRequestHeader("Origin", "dev-admin.foodhunt.com");
      //request.setRequestHeader("Host", "dev-order-api.foodhunt.com");
      request.send();
    },
  },
  beforeRouteLeave(to, from, next) {
    //this.$store.dispatch("Auth/setWorkState", "working");
    //console.log("clearInterval");
    //clearInterval(this.refresh);
    next();
  },
};
</script>
<style>
tbody tr:nth-of-type(even) {
  background-color: rgb(241, 241, 241);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}

.v-data-table-header {
  background-color: rgba(182, 183, 187);
  color: white;
}

.v-data-footer {
  background-color: rgb(250, 250, 250);
}

.theme--light.v-data-table thead tr th {
  color: white;
}

#stat .el-card__body {
  padding: 3px 12px !important;
}
</style>
